// Mutations
export const SET_CALENDAR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.calendar.data = payload
    state.calendar.lastUpdate = new Date()
  }
}
export const ADD_CALENDAR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.calendar.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.calendar.data.push(data)
      }
    })
  }
}
export const SET_CALENDAR_LOADING = (state, payload) => {
  state.calendar.loading = payload
}

export const SET_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clients.data = payload
    state.clients.lastUpdate = new Date()
  }
}
export const ADD_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.clients.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clients.data.push(data)
      }
    })
  }
}
export const SET_CLIENTS_LOADING = (state, payload) => {
  state.clients.loading = payload
}
